import { defineComponent, h } from 'vue';
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';

// Register necessary components from Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default defineComponent({
  name: 'App',
  components: {
    Bar
  },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',  // This changes the chart to horizontal
        plugins: {
          legend: {
            display: false,
            position: 'bottom', // Positioning the legend
            padding: 25,
            labels: {
              font: {
                // Add font options here if needed
              }
            }
          },
          tooltip: {
            callbacks: {
              title: () => "",
              label: function(context) {
                let label = context.dataset.label || '';
                let label2 = "";
                let index = context.dataIndex;
                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  if (context.parsed.y > 0) {
                    label2 += "";
                  }
                  label += context.dataset.tooltips[index];
                  label2 += context.parsed.x + " Tonnes";
                }
                if (context.dataset.tooltips[index] === "") {
                  return [label2];
                } else {
                  return [label, label2];
                }
              }
            }
          },
          datalabels: {
            display: false // Disable data labels on bars
          }
        },
        scales: {
          x: {  // Adjusted for horizontal bars
            position: 'left',
            grid: {
              display: true,
              color: "#e4e6e8",
            },
            ticks: {
              maxTicksLimit: 10,
              font: {
                size: 10
              },
            }
          },
          y: {
            grid: {
              display: false
            },
            ticks: {
              maxTicksLimit: 20,
              font: {
                size: 10
              },
              maxRotation: 0,
              minRotation: 0,
            }
          }
        }
      }
    };
  },
  render() {
    return h('div', { style: { height: '500px' } }, [ // Set height directly
      h(Bar, {
        data: this.chartData,
        options: this.options
      })
    ]);
  }
});
